
<div class="showcase-collections-view">
  <align flex collapse-end direction="flex-start">
    <div class="showcase-input-wrapper">
      <search-area
        v-model="query"
        class="input"
      />
    </div>

    <direction-sort-options
      :sort.sync="sort"
      :direction.sync="direction"
      :options="sortOptions"
    />
  </align>

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      title="There are no results for your query"
      description="Try searching for something else"
    />

    <template>
      <div class="list">
        <div
          v-for="collection in collections"
          :key="collection.id"
        >
          <showcase-collection-item :collection="collection" />
        </div>
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="loadMore"
      />
    </template>
  </div>

  <scroll-top />
</div>
